/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
// Extends From
import Route from '@ember/routing/route';

// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// External Imports
import { hash } from '@linc-technologies/linced-common/utils/promise';
import Scopes from '@linc-technologies/linced-common/enums/scopes';

export default class ManageSettingsRoute extends Route {
  // Services
  @service
  permissions;

  @service
  router;

  @service
  session;

  @service
  store;

  model() {
    let person = this.modelFor('people.person').person;
    let personId = person.id;
    let devices = [];

    // For Devices settings
    if (this.permissions.meet(Scopes.LINCED_MANAGER)) {
      // Hero Managers and above have permission to list user devices.
      devices = this.store.query('device', { personId });
    }

    // For Security settings
    let userId = person.get('userId');
    let user = null;
    if (!isEmpty(userId)) {
      // Not all people have user accounts,
      // and the user model for others is not available without a request
      user = this.store
        .findRecord('user', userId)
        .then((userRecord) => userRecord)
        // Some caregivers will not have access to the school the admin is from
        // due to not having access to their only child at this school.
        // Getting an error is unavoidable as there is no way currently
        // to check caregivers' tenant access without the user record.
        // So we nullify the error and return nothing to the user object
        .catch(() => null);
    }

    return hash({
      person,
      devices,
      user,
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);

    // Redirect to the user's settings page if they are trying to manage settings
    // using admin rights for themselves
    if (this.session.get('personId') === model.person.id) {
      this.router.transitionTo('my-profile');
    }
  }

  resetController() {
    super.resetController(...arguments);
    this.controller.reset();
  }
}
